<script lang="ts">
	import { flowEditorState } from '../../../../stores/flow_editor';
	import MathStep from '../../../Scenes/SceneWizard/Process/When/AddEditContionWizard/Steps/MathBased/MathStep.svelte';
	import { create_math_condition } from '../../../Scenes/helpers/ui_conditions_to_scene';
	import { mathConditionInterpretator } from '../../../Scenes/helpers/scene_conditions_to_ui';
	import type { MathConditionUI } from '../../../../types/Scenes/MathConditionUI';

	export let nodeId: string;

	let initializedNodeId = '';
	let editorSceneData: any = null;

	$: node = $flowEditorState.nodes.find((candidate) => candidate.id === nodeId);
	$: if (node && initializedNodeId !== node.id) initialize(node.data);

	function initialize(data: any) {
		const translated: MathConditionUI =
			data.sceneData?._gui_type === 'math_based'
				? mathConditionInterpretator(data.sceneData)
				: {
						math_script: data.mathScript || {},
						expression: String(data.expression || ''),
						params: Array.isArray(data.params) ? [...data.params] : [],
						_gui_type: 'math_based',
					};

		editorSceneData = {
			translated,
			_math_condition: { ...translated, params: [...translated.params] },
			isValid: Boolean(data.isConfigured),
		};
		initializedNodeId = nodeId;
	}

	function handleMathChange(mathCondition: MathConditionUI, isValid: boolean) {
		if (!node) return;
		const sceneData = create_math_condition(mathCondition);
		const expression = mathCondition.expression.trim();

		flowEditorState.updateNode(nodeId, {
			data: {
				...node.data,
				label: expression ? `When ${expression}` : 'Math Expression',
				expression,
				params: [...mathCondition.params],
				mathScript: mathCondition.math_script,
				sceneData,
				originalCondition: undefined,
				isValid,
				isConfigured: isValid,
				requiresConfiguration: !isValid,
			},
		});
	}
</script>

{#if editorSceneData}
	<div class="math-condition-inspector">
		<MathStep sceneData={editorSceneData} onChange={handleMathChange} />
	</div>
{/if}

<style>
	.math-condition-inspector :global(h2) {
		font-size: 1rem;
	}
	.math-condition-inspector :global(.mb-l) {
		margin-bottom: 1rem;
	}
</style>
